<script lang="ts">
    import { menuIsExpanded } from '@amp/web-app-components/src/components/Navigation/store/menu-state';
</script>

<!-- JS is using the data-main-content attribute to get this element for scroll area to define the sticky header -->
<!--
    NOTE: this ID is depended on for history scroll restoration and is
            cited in FlowAction handler
-->
<div
    id="scrollable-page"
    class="scrollable-page"
    data-main-content
    data-testid="main-section"
    aria-hidden={$menuIsExpanded}
    role="group"
>
    <slot />
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/core' as *;
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .scrollable-page {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        grid-area: structure-main-section;
        overflow-x: hidden;
        overflow-y: auto;
        scroll-padding-bottom: 80px; // Scroll focused content above floating player or fixed banner
        transition: margin 0.1s linear, width 0.1s linear;
        z-index: var(--z-default);

        @media (--sidebar-visible) {
            margin-top: $global-player-bar-height;
        }

        @media (--medium) {
            @include feature-detect(is-drawer-open) {
                width: calc(100% - 300px);
                margin-inline-end: 300px;
            }
        }

        @include feature-detect(scroll-is-locked) {
            overflow-y: hidden;
        }

        @include feature-detect(needs-gdpr) {
            display: none;
        }

        // Maximize content area for Replay Highlights
        &:global(.maximize-content-area) {
            padding-top: 0;
            transition: padding-top 250ms;
        }

        &:global(.noscroll) {
            overflow: hidden;
        }
    }
</style>
